module.exports = __webpack_public_path__ + "img/default_img43.21515497.jpg";